package com.shadowings.gero.domain.usecase

import com.shadowings.gero.domain.repository.UserDataRepository
import kotlinx.coroutines.flow.first

/**
 * Rimuove un cuore al giocatore quando sbaglia una risposta (con un minimo di zero).
 * Logica di business → appartiene al domain layer, non al repository.
 */
class RemoveHeartUseCase(
    private val userDataRepository: UserDataRepository,
) {
    suspend operator fun invoke(isCorrect: Boolean) {
        // Rimuovi un cuore SOLO se la risposta è sbagliata
        if (isCorrect) return

        val current = userDataRepository.userData.first().hearts
        if (current > 0) {
            userDataRepository.setHearts(current - 1)
        }
    }
}


